import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ContactEmailRenderer extends Component {
  renderValue() {
    const { value, data } = this.props;
    const subject = 'Feedback on your experience';
    const body = `
Hi ${data.first_name},
%0D%0A%0D%0AI would like to understand how I can improve and become a better partner in the future. When you have a moment, please click the following link to provide candid feedback on your experience evaluating us: ${data.survey_url}`;
    const { email } = data;
    return (
      <a
        href={`mailto:${email}?subject=${subject}&body=${body}`}
      >
        {value}
      </a>
    );
  }

  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderValue();
    }
    return null;
  }
}

ContactEmailRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    survey_url: PropTypes.string,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
ContactEmailRenderer.defaultProps = {
  value: null,
  data: null,
  node: null,
};

export default ContactEmailRenderer;
